export { MobileSliderView } from "./MobileSliderView";
